export enum OcTerminationReason {
    Last_period_day = 'Last_period_day',
    Another_insurer = 'Another_insurer',
    After_vehicle_acquiring = 'After_vehicle_acquiring',
};